import React from "react";
export const Logo = ({
  className = "",
  textColor = "text-cs-purple"
}: {
  className?: string;
  textColor?: string;
}) => {
  return <div className={`flex items-center ${className}`}>
      <div className="mr-2">
        <img src="/lovable-uploads/ee2c8437-420b-4547-809c-1dff637aa96f.png" alt="City & Sanctuary Logo" width="36" height="36" className="text-cs-purple dark:text-white" />
      </div>
      <div className="flex flex-col items-start">
        <span className={`font-display text-xl font-bold my-px px-[12px] py-0 ${textColor}`}>
          CITY &amp; SANCTUARY
        </span>
        
      </div>
    </div>;
};

export const LogoIcon = ({
  className = ""
}: {
  className?: string;
}) => {
  return <div className={className}>
      <img src="/lovable-uploads/ee2c8437-420b-4547-809c-1dff637aa96f.png" alt="City & Sanctuary Logo" width="36" height="36" className="text-cs-purple dark:text-white" />
    </div>;
};
